import { Dialog } from '@angular/cdk/dialog';
import {
  booleanAttribute,
  Component,
  EventEmitter,
  inject,
  input,
  type OnInit,
  Output,
} from '@angular/core';
import { FinoButtonModule } from '@fino-ui/button';
import { FinoIconModule } from '@fino-ui/icon';
import { FinoInputModule } from '@fino-ui/input';
import {
  FinoTranslationModule,
  TranslationService,
} from '@fino-ui/translation';
import {
  REJECTION_REASONS,
  REJECTION_REASONS_DETAILED,
  REJECTION_REASONS_GENERAL,
  REJECTION_REASONS_HIDDEN_FOR_DOCUMENT_TYPES,
} from '../identify-document.constants';
import { IdentifyDocumentService } from '../identify-document.service';

@Component({
  selector: 'app-rejection-reason',
  imports: [
    FinoTranslationModule,
    FinoButtonModule,
    FinoInputModule,
    FinoIconModule,
  ],
  templateUrl: './rejection-reason.component.html',
})
export class RejectionReasonComponent implements OnInit {
  private readonly identifyDocumentService = inject(IdentifyDocumentService);
  private readonly dialog = inject(Dialog);
  private readonly translateService = inject(TranslationService);

  readonly jobId = input<string>(undefined);
  readonly documentType = input<string>(undefined);
  readonly form = input(undefined);
  readonly tenantInfos = input(undefined);
  readonly isClarification = input<boolean, unknown>(undefined, {
    transform: booleanAttribute,
  });
  @Output() deleteJobDone = new EventEmitter();

  rejectionReasonVisible: boolean = false;

  get rejectionReason() {
    return this.form().value.rejectionReason;
  }

  get rejectionReasonsGeneral() {
    return REJECTION_REASONS_GENERAL;
  }

  get rejectionReasons() {
    return REJECTION_REASONS;
  }

  get rejectionReasonsDetailed() {
    return REJECTION_REASONS_DETAILED;
  }

  get hasRejectionReasonOther() {
    const { value } = this.form().controls.rejectionReason;
    return (
      value !== this.rejectionReasons.OK &&
      value !== this.rejectionReasons.NEEDS_CLARIFICATION
    );
  }

  get hideRejectionReasons() {
    return REJECTION_REASONS_HIDDEN_FOR_DOCUMENT_TYPES.includes(
      this.documentType(),
    );
  }

  openDeleteModal() {
    this.identifyDocumentService.openDeleteModal().subscribe((approved) => {
      if (approved) this.deleteJob();
    });
  }

  ngOnInit(): void {
    this.form()
      .get('rejectionReason')
      ?.valueChanges.subscribe((rejectionReason) => {
        this.form()
          .get('rejectionReasonText')
          ?.setValue(
            this.translateService.instant(
              `rejectionReason.${rejectionReason}.text`,
            ),
          );
      });
  }

  rejectionReasonTemplate(type: string) {
    if (type === 'mailInfo') {
      this.form()
        .get('rejectionReasonText')
        ?.setValue(
          this.form().get('rejectionReasonText')?.value +
            '\n' +
            this.translateService.instant(type, {
              name: this.tenantInfos()?.bankName,
              mail: this.tenantInfos()?.kwhEmail,
            }),
        );
      return;
    }
    this.setRejectionReason(type);
    this.form()
      .get('rejectionReasonText')
      ?.setValue(this.translateService.instant(`rejectionReason.${type}.text`));
  }

  setRejectionReason(reason: string) {
    this.rejectionReasonVisible = true;
    this.form().get('rejectionReason')?.setValue(reason);
  }

  deleteJob() {
    this.identifyDocumentService.deleteSubscription =
      this.identifyDocumentService.deleteJob(this.jobId()).subscribe((_r) => {
        this.dialog.closeAll();
        this.deleteJobDone.emit();
      });
  }
}
